module.exports = __webpack_public_path__ + "static/media/close_grey.71acb7c6.svg";